export default __webpack_public_path__ + "static/media/peach3.94a1c744.png";